import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import FalconCardHeader from 'components/common/FalconCardHeader';
import IconButton from 'components/common/IconButton';
import SoftBadge from 'components/common/SoftBadge';
import TableRowAction from 'components/common/TableRowAction';
import { weDonorInvoiceData } from 'data/weraise-data/donar-data';
import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import DonorCommunicationModal from './modals/DonorCommunicationModal';

const DonorCommunications = () => {
  const [modalShow, setModalShow] = useState(false);

  const columns = [
    {
      accessor: 'ref',
      Header: 'Ref',
      cellProps: {
        className: 'fw-medium py-2'
      },
      Cell: rowData => {
        const { ref } = rowData.row.original;
        return (
          <Button
            onClick={() => setModalShow(true)}
            variant="link"
            size="sm"
            className="p-0"
          >
            {ref}
          </Button>
        );
      }
    },
    {
      accessor: 'date',
      Header: 'Date',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'type',
      Header: 'Type',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: {
        className: 'fw-medium py-2'
      },
      Cell: rowData => {
        return (
          <SoftBadge pill bg={rowData.row.original.variant} className="me-2">
            {rowData.row.original.status}{' '}
            <FontAwesomeIcon icon={rowData.row.original.icon} />
          </SoftBadge>
        );
      }
    },
    {
      accessor: 'title',
      Header: 'Title',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'id',
      Header: '',
      cellProps: {
        className: 'py-2 text-end'
      },
      disableSortBy: true,

      Cell: rowData => {
        const { id } = rowData.row;
        return (
          <TableRowAction
            onCLickEdit={() => console.log(id)}
            onCLickDelete={() => console.log(id)}
          />
        );
      }
    }
  ];

  return (
    <>
      <Card className="mb-3">
        <FalconCardHeader
          title={<h4 className="mt-2 fw-bold">Communications</h4>}
          light={false}
          titleTag="div"
          menuClassName="align-items-center"
          endEl={
            <IconButton icon="plus" transform="shrink-3">
              <span className="d-none d-md-inline-block ms-2">
                Add Donation
              </span>
            </IconButton>
          }
        />
      </Card>
      <Row>
        <Col md={12} xxl={12} className="h-md-100">
          <CustomAdvanceTable
            data={weDonorInvoiceData}
            columns={columns}
            title="Communications"
            showSearchInput
            searchInputPlaceHolder="Search"
            addNew
            perPage={10}
          />
        </Col>
      </Row>
      <DonorCommunicationModal
        modalShow={modalShow}
        setModalShow={setModalShow}
      />
    </>
  );
};

export default DonorCommunications;
